import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  FieldInputDollar,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
} from "../../../utils";
import {
  download316ReportInfo,
  get316ReportInfo,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";
import { Tooltip } from "@progress/kendo-react-tooltip";
import data from "../../Mapper/MapAndTransform/sampleData";

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    if (value === null) return <td></td>;
    return <td>$ {(Math.round(value * 100) / 100).toFixed(2)}</td>;
  }
}

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}

const today = new Date();
const initialValues = {
  //companyName: "Select One",
  payDateTo: new Date(today.setDate(today.getDate())),
  payDateFrom: new Date(today.setDate(today.getDate() - 30)),
  companyId: null,
};

//const selectOne = { label: "Select One", value: null };
const allOption = { label: "All", value: null };

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 250,
    dataType: "alphaNumeric",
    field1: "ssn",
  },
  {
    value: 2,
    label: "Last name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 3,
    label: "First name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 173,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 4,
    label: "Middle initial",
    className: "column-middleInitial",
    columnName: "middleInitial",
    field: "middleInitial",
    width: 120,
    dataType: "alphaNumeric",
    field1: "middleInitial",
  },

  {
    value: 5,
    label: "Birth date*",
    className: "column-birthDate",
    columnName: "birthDate",
    field: "birthDate",
    width: 250,
    dataType: "date",
    field1: "birthDateFrom",
    field2: "birthDateTo",
  },
  {
    value: 6,
    label: "Gender",
    className: "column-gender",
    columnName: "gender",
    field: "gender",
    width: 250,
    dataType: "alphaNumeric",
    field1: "gender",
  },
  {
    value: 7,
    label: "Original Hire date*",
    className: "column-hireDate",
    columnName: "hireDate",
    field: "hireDate",
    width: 250,
    dataType: "date",
    field1: "hireDateFrom",
    field2: "hireDateTo",
  },
  {
    value: 8,
    label: "Termination date",
    className: "column-terminationDate",
    columnName: "terminationDate",
    field: "terminationDate",
    width: 250,
    dataType: "date",
    field1: "terminationDateFrom",
    field2: "terminationDateTo",
  },
  {
    value: 9,
    label: "Employee Status Change",
    className: "column-employeeStatusChange",
    columnName: "employeeStatusChange",
    field: "employeeStatusChange",
    width: 250,
    dataType: "alphaNumeric",
    field1: "employeeStatusChange",
  },
  {
    value: 10,
    label: "Rehire date",
    className: "column-rehireDate",
    columnName: "rehireDate",
    field: "rehireDate",
    width: 250,
    dataType: "date",
    field1: "rehireDateFrom",
    field2: "rehireDateTo",
  },
  {
    value: 11,
    label: "LTPT",
    className: "column-ltpt",
    columnName: "ltpt",
    field: "ltpt",
    width: 250,
    dataType: "alphaNumeric",
    field1: "ltpt",
  },
  {
    value: 12,
    label: "Hours",
    className: "column-hours",
    columnName: "hours",
    field: "hours",
    width: 250,
    dataType: "numeric",
    field1: "hoursFrom",
    field2: "hoursTo",
  },
  {
    value: 13,
    label: "Gross compensation",
    className: "column-grossCompensation",
    columnName: "grossCompensation",
    field: "grossCompensation",
    width: 250,
    dataType: "amount",
    field1: "grossCompensationFrom",
    field2: "grossCompensationTo",
  },
  {
    value: 14,
    label: "Has Self-Employment Income",
    className: "column-hasSelfEmploymentIncome",
    columnName: "hasSelfEmploymentIncome",
    field: "hasSelfEmploymentIncome",
    width: 250,
    dataType: "alphaNumeric",
    field1: "hasSelfEmploymentIncomeFrom",
    field2: "hasSelfEmploymentIncomeTo",
  },
  {
    value: 15,
    label: "Compensation From Plan Entry Date",
    className: "column-postEntryPlanCompensation",
    columnName: "postEntryPlanCompensation",
    field: "postEntryPlanCompensation",
    width: 300,
    dataType: "amount",
    field1: "postEntryPlanCompensationFrom",
    field2: "postEntryPlanCompensationTo",
  },
  {
    value: 16,
    label: "Excluded Compensation - Fringe",
    className: "column-excludedCompensationFringe",
    columnName: "excludedCompensationFringe",
    field: "excludedCompensationFringe",
    width: 300,
    dataType: "alphaNumeric",
    field1: "excludedCompensationFringeFrom",
    field2: "excludedCompensationFringeTo",
  },
  {
    value: 17,
    label: "Excluded Compensation - Bonus",
    className: "column-excludedCompensationBonus",
    columnName: "excludedCompensationBonus",
    field: "excludedCompensationBonus",
    width: 300,
    dataType: "alphaNumeric",
    field1: "excludedCompensationBonusFrom",
    field2: "excludedCompensationBonusTo",
  },
  {
    value: 18,
    label: "Excluded Compensation - Overtime",
    className: "column-excludedCompensationOvertime",
    columnName: "excludedCompensationOvertime",
    field: "excludedCompensationOvertime",
    width: 300,
    dataType: "alphaNumeric",
    field1: "excludedCompensationOvertimeFrom",
    field2: "excludedCompensationOvertimeTo",
  },
  {
    value: 19,
    label: "Excluded Compensation - Commission",
    className: "column-excludedCompensationCommission",
    columnName: "excludedCompensationCommission",
    field: "excludedCompensationCommission",
    width: 300,
    dataType: "alphaNumeric",
    field1: "excludedCompensationCommissionFrom",
    field2: "excludedCompensationCommissionTo",
  },
  {
    value: 20,
    label: "Excluded Compensation - Other",
    className: "column-excludedCompensationOther",
    columnName: "excludedCompensationOther",
    field: "excludedCompensationOther",
    width: 300,
    dataType: "alphaNumeric",
    field1: "excludedCompensationOtherFrom",
    field2: "excludedCompensationOtherTo",
  },
  {
    value: 21,
    label: "Severance Compensation",
    className: "column-serveranceCompensation",
    columnName: "serveranceCompensation",
    field: "serveranceCompensation",
    width: 300,
    dataType: "alphaNumeric",
    field1: "serveranceCompensationFrom",
    field2: "serveranceCompensationTo",
  },
  {
    value: 22,
    label: "Employee Pretax Salary Deferral",
    className: "column-pretax",
    columnName: "pretax",
    field: "pretax",
    width: 250,
    dataType: "amount",
    field1: "pretaxFrom",
    field2: "pretaxTo",
  },
  {
    value: 23,
    label: "Employee Roth Salary Deferral",
    className: "column-roth",
    columnName: "roth",
    field: "roth",
    width: 250,
    dataType: "amount",
    field1: "rothFrom",
    field2: "rothTo",
  },
  {
    value: 24,
    label: "Employer Safe Harbor Contribution",
    className: "column-employerSafeHarborContribution",
    columnName: "employerSafeHarborContribution",
    field: "employerSafeHarborContribution",
    width: 250,
    dataType: "amount",
    field1: "employerSafeHarborContributionFrom",
    field2: "employerSafeHarborContributionTo",
  },
  {
    value: 25,
    label: "Employer Match Contribution",
    className: "column-employerMatch",
    columnName: "employerMatch",
    field: "employerMatch",
    width: 250,
    dataType: "amount",
    field1: "employerMatchFrom",
    field2: "employerMatchTo",
  },
  {
    value: 26,
    label: "Other Employer Contribution",
    className: "column-otherEmployerContribution",
    columnName: "otherEmployerContribution",
    field: "otherEmployerContribution",
    width: 250,
    dataType: "amount",
    field1: "otherEmployerContributionFrom",
    field2: "otherEmployerContributionTo",
  },
  {
    value: 27,
    label: "Employee After tax Contribution",
    className: "column-aftertax",
    columnName: "aftertax",
    field: "aftertax",
    width: 250,
    dataType: "amount",
    field1: "aftertaxFrom",
    field2: "aftertaxTo",
  },
  {
    value: 28,
    label: "Salaried Employee",
    className: "column-salariedEmployee",
    columnName: "salariedEmployee",
    field: "salariedEmployee",
    width: 250,
    dataType: "alphaNumeric",
    field1: "salariedEmployee",
  },
  {
    value: 29,
    label: "Union employee",
    className: "column-ssn",
    columnName: "unionEmployee",
    field: "unionEmployee",
    width: 250,
    dataType: "alphaNumeric",
    field1: "unionEmployee",
  },
  {
    value: 30,
    label: "HPI Indicator",
    className: "column-hpiIndicator",
    columnName: "hpiIndicator",
    field: "hpiIndicator",
    width: 250,
    dataType: "alphaNumeric",
    field1: "hpiIndicator",
  },
  {
    value: 31,
    label: "Leased Employee",
    className: "column-leasedEmployee",
    columnName: "leasedEmployee",
    field: "leasedEmployee",
    width: 250,
    dataType: "alphaNumeric",
    field1: "leasedEmployee",
  },

  {
    value: 32,
    label: "Excluded Job Classification",
    className: "column-excludedJobClassification",
    columnName: "excludedJobClassification",
    field: "excludedJobClassification",
    width: 250,
    dataType: "alphaNumeric",
    field1: "excludedJobClassificationFrom",
    field2: "excludedJobClassificationTo",
  },

  {
    value: 33,
    label: "Division or Location",
    className: "column-divisionOrLocation",
    columnName: "divisionOrLocation",
    field: "divisionOrLocation",
    width: 250,
    dataType: "alphaNumeric",
    field1: "divisionOrLocation",
  },
  {
    value: 34,
    label: "Notes",
    className: "column-notes",
    columnName: "notes",
    field: "notes",
    width: 250,
    dataType: "alphaNumeric",
    field1: "notes",
  },
];

const Report316 = (props) => {
  const [final, setFinal] = useState(columns);
  const [gridFilters, setGridFilters] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);

  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
  ]);
  const [totalRecord, setTotalRecord] = useState(0);
  const formName = manageReportsFormNames.REPORT_316_CENSUS;
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [sponsorList, setSponsorList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [trigger, setTrigger] = useState(true);

  const [isScroll, setIsScroll] = useState(false);
  const [sorting, setSorting] = useState();
  const [tableContent, setTableContent] = useState([]);

  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });
  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });

  const apiCall = (data) => {
    setDataLoading(true);
    get316ReportInfo(data)
      .then((response) => {
        setDataLoading(false);
        setTableContent(response.report316CensusData);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
        //handle error
      });

    setToggle(!toggle);
  };

  useDeepEffect(() => {
    if (!isEmpty(gridFilters)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
        from: 1,
        count: 20,
      });
      setPageCount(1);
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponsorList(values.sponsorOrganizationName);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        payDateFrom: usDateFormat(values.payDateFrom),
        payDateTo: usDateFormat(values.payDateTo),
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setTableContent([]);
      setCompanyList("");
      setSponsorList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          payDateFrom: filteredValues.payDateFrom,
          payDateTo: filteredValues.payDateTo,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        get316ReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.report316CensusData.length === 0) {
              setIsScroll(false);
            } else {
              setTableContent([
                ...tableContent,
                ...response.report316CensusData,
              ]);
            }
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns([final.map((item) => item.value)]);

    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };

  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);

    download316ReportInfo({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `AnnualAdminCensusReport_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div> </div>}</td>;
  };
  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };
  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };
  const booleanFieldRender = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    let temp = "-";
    if (value === true) temp = "YES";
    else if (value === false) temp = "NO";
    return renderValue(temp);
  };

  return (
    <ManageReportLayout rptName="Annual Admin Census Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex ">
                    <div className="d-flex mr-2">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "130px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.sponsorOrganizationName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-3 SSN-style">
                        <Field
                          noLabelTransform
                          size="sm"
                          isRequired
                          label="Plan ID"
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              label="Select plan"
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Pay date from "
                          isRequired
                          name={fields.payDateFrom}
                          value={usDateFormat(values[fields.payDateFrom])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.payDateFrom, "")}
                          validate={(value) =>
                            ["", undefined, null, "Select One"].includes(
                              value
                            ) && isEmpty(values[fields.payDateFrom])
                              ? "Required"
                              : null
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateFrom, value)
                              }
                              value={usDateFormat(values[fields.payDateFrom])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-3">
                        <Field
                          size="sm"
                          label="Pay date to"
                          isRequired
                          name={fields.payDateTo}
                          value={usDateFormat(values[fields.payDateTo])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.payDateTo, "")}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateTo, value)
                              }
                              value={usDateFormat(values[fields.payDateTo])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value < values[fields.payDateFrom] ? (
                              <div style={{ width: "150px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Button
                      className=" mt-12 sort-button mr-3"
                      variant="secondary"
                      style={{ marginTop: "30px" }}
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.planName,
                              fields.companyId,
                              fields.companyName,
                              fields.sponsorOrganizationName,
                              fields.sponsorOrganizationId,
                              fields.amountFrom,
                              fields.amountTo,
                              fields.payDateFrom,
                              fields.payDateTo,
                            ],
                          }),
                        });
                        setFieldValue(
                          fields.payDateFrom,
                          initialValues.payDateFrom
                        );
                        setFieldValue(
                          fields.payDateTo,
                          initialValues.payDateTo
                        );
                        setFieldValue(fields.nameOrSsn, "");
                        setFieldValue(fields.planName, null);
                        setFieldValue(fields.planId, null);
                        setPlanList([]);
                        setErrors({});
                        setTotalRecord(0);
                        setTableContent([]);
                        setCompanyList("");
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      className="mt-12 sort-button"
                      style={{
                        lineHeight: "19px",
                        marginLeft: "8px",
                        marginTop: "30px",
                      }}
                      variant="secondary"
                      type="submit"
                    >
                      Search
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
          <div className="d-flex flex-col">
            <div
              style={{ fontSize: "14px", color: "#828282", paddingTop: "6px" }}
            >
              {companyList ? `Showing result for ${companyList} company` : null}
            </div>
            <div className="ft-12 grey-text font-weight-500">
              {totalRecord} Records found
            </div>
          </div>
          <div className="d-flex pad-top-10">
            <div style={{ diplay: "flex", flexDirection: "column" }}>
              <div>
                <Button
                  variant="secondary"
                  className="column-header"
                  onClick={showManageColumns}
                >
                  <span className="marg-right-6">
                    <i class="fal fa-columns"></i>
                  </span>
                  Column
                </Button>
              </div>
              <div
                className="manage-column-dropdown"
                style={{ display: "none" }}
              >
                <div className="manage-columns ">
                  <p className="manage-columns-button"> Manage columns</p>
                  <p
                    className="apply-button"
                    onClick={() => {
                      hideColumns();
                      setTrigger(!trigger);
                    }}
                  >
                    Close
                  </p>
                </div>
                <div>
                  <MultiSelectDropdown
                    hideSelectedOptions="FALSE"
                    width="269px"
                    height="200px"
                    maxHeight="300px"
                    position="absolute"
                    background="white"
                    zIndex="2"
                    options={columns}
                    onSelect={(value) => {
                      setSelectedColumns(value);
                    }}
                    name={"Columns"}
                    value={selectedColumns}
                    trigger={trigger}
                    // disabled={}
                    // isTypeAhead={isEdit}
                  />
                </div>
                <div style={{ marginTop: "220px", paddingLeft: "100px" }}>
                  <Button onClick={applyColumns}>Apply</Button>
                </div>
              </div>
            </div>
            <div className="ft-12 grey-text font-weight-500 marg-right-5">
              <Button
                className="export-button"
                title="Export Excel"
                variant="secondary"
                style={{ border: "none" }}
                // onClick={<ExcelExport />}
                onClick={() => !isEmpty(tableContent) && exportReportFile()}
              >
                <Image src={ExcelImage} width="20px" />
                Export
              </Button>
            </div>
          </div>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={tableContent}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={tableContent}
                  total={tableContent?.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "boolean" && booleanFieldRender) ||
                        (column.dataType === "date" && dateForm) ||
                        renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(tableContent) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default Report316;
